import { render, staticRenderFns } from "./LiveNotes.vue?vue&type=template&id=33b0efad&scoped=true"
import script from "./LiveNotes.js?vue&type=script&lang=js&external"
export * from "./LiveNotes.js?vue&type=script&lang=js&external"
import style0 from "./LiveNotes.vue?vue&type=style&index=0&id=33b0efad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b0efad",
  null
  
)

export default component.exports